import React from 'react';
import PropTypes from 'prop-types';

import { FieldArray, Fields } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import OrderInformationGeneral from './OrderInformationGeneral';
import OrderInformationVitals from './OrderInformationVitals';
import OrderInformationPrescriber from './OrderInformationPrescriber';
import OrderInformationDiagnoses from './OrderInformationDiagnoses';
import OrderInformationReferralSource from './OrderInformationReferralSource';
import OrderInformationSalesRepresentative from './OrderInformationSalesRepresentative';
import OrderInformationResubmission from './OrderInformationResubmission';

const styles = theme => ({
  root: {
    marginTop: 15,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
});

const OrderInformation = ({
  Patient,
  Diagnosis,
  Vitals,
  classes,
  formValues,
  systemSettings,
  disabled,
  ...otherProps
}) => (
  <Paper className={classes.root}>
    <OrderInformationGeneral
      {...Patient}
      change={otherProps.change}
      formValues={formValues}
      systemSettings={systemSettings}
      disabled={disabled}
    />
    <OrderInformationPrescriber
      Patient={Patient}
      change={otherProps.change}
      formValues={formValues}
      disabled={disabled}
    />
    <FieldArray
      name="Diagnosis ID"
      component={OrderInformationDiagnoses}
      Diagnosis={Diagnosis}
      Patient={Patient}
      formValues={formValues}
      disabled={disabled}
    />
    <FieldArray
      name="Vitals ID"
      component={OrderInformationVitals}
      Vitals={Vitals}
      Patient={Patient}
      disabled={disabled}
    />
    <OrderInformationReferralSource
      change={otherProps.change}
      Patient={Patient}
      formValues={formValues}
      disabled={disabled}
    />
    <FieldArray
      name="Sales Representative ID"
      component={OrderInformationSalesRepresentative}
      {...{ 'Sales Representative': otherProps['Sales Representative'] }}
      Patient={Patient}
      formValues={formValues}
      disabled={disabled}
    />
    <Fields
      names={[
        'Insurances',
        'Resubmission',
        'Original Ref Number',
      ]}
      component={OrderInformationResubmission}
      disabled={disabled}
    />
  </Paper>
);

OrderInformation.propTypes = {
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number.isRequired,
  }).isRequired,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  Vitals: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  'Sales Representative': PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })),
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  systemSettings: PropTypes.object,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformation.defaultProps = {
  Facility: null,
  Diagnosis: null,
  Vitals: null,
  'Sales Representative': null,
  formValues: {},
  systemSettings: {},
  disabled: false,
};

export default withStyles(styles)(OrderInformation);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformation.js